export default {
      id: "balancer-usage",
      viewBox: "0 0 32 29",
      url: __webpack_public_path__ + "sprite.svg#balancer",
      toString: function () {
        return this.url;
      }
    }